<template>
  <v-dialog v-model="open" :max-width="width" persistent>
    <v-card :class="['reg-dialog', dialogClass]">
      <v-toolbar v-if="title" flat>
        <v-icon v-if="titleIcon" color="primary" class="mr-2">
          {{ titleIcon }}
        </v-icon>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn v-if="closeable"
                 icon
                 @click="onClose">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <v-card-text class="mt-4">
        <p class="subtitle text-prefer-wrap px-2" v-html="message" />
        <template v-if="typeToConfirm">
          <p v-html="$t('type_to_confirm', {text: textToCompare})" />
          <v-text-field v-model="text" :placeholder="$t('type_here')" />
        </template>
      </v-card-text>
      <v-card-actions class="gap-h">
        <v-spacer />
        <v-btn v-if="!hideCancel"
               v-shortkey="['esc']"
               :text="cancelFlat"
               large
               :color="cancelColor"
               class="reg-btn-lower subtitle"
               @shortkey="onCancel()"
               @click.stop="onCancel()">
          <v-icon v-if="cancelIcon" class="mr-2">
            {{ cancelIcon }}
          </v-icon>
          {{ cancelText }}
        </v-btn>
        <v-btn ref="detaultButton"
               v-shortkey="['enter']"
               :disabled="!canConfirm"
               :color="confirmColor"
               large
               depressed
               class="reg-btn-lower subtitle"
               @shortkey="onConfirm()"
               @click.stop="onConfirm()">
          <v-icon class="mr-2">
            {{ confirmIcon }}
          </v-icon>
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleIcon: {
      type: String,
      default: 'mdi-alert'
    },
    message: {
      type: String,
      default: ''
    },
    hideCancel: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Ok'
    },
    confirmIcon: {
      type: String,
      default: 'mdi-check'
    },
    confirmColor: {
      type: String,
      default: 'primary'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    cancelFlat: {
      type: Boolean,
      default: true
    },
    cancelColor: {
      type: String,
      default: 'primary'
    },
    cancelIcon: {
      type: String,
      default: ''
    },
    typeToConfirm: {
      type: Boolean,
      default: false
    },
    textToCompare: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '450px'
    },
    closeable: {
      type: Boolean,
      default: false
    },
    dialogClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      open: false,
      text: ''
    }
  },
  computed: {
    canConfirm() {
      return this.typeToConfirm ? this.textToCompare === this.text : true
    }
  },
  methods: {
    onConfirm() {
      this.open = false
      this.$emit('confirm')
    },
    onCancel() {
      this.open = false
      this.$emit('cancel')
    },
    onClose() {
      this.open = false
      this.$emit('close')
    }
  }
}
</script>
